/**
 * Persist Health Sprint progress to `stages` (answers as 1-based indices, meters).
 */
export async function updateStage({
  userId,
  token,
  stageId,
  answers,
  energy,
  time,
  health,
  currentDay,
  /** When set, server merges into `questions` JSON (e.g. power-up usage). */
  powerup,
  /** UI snapshot for resume-after-refresh (screen, powerups left, etc.). */
  resume,
  /** When true, clears `questions` metadata then re-applies powerup/resume from this request. */
  resetQuestionsMeta,
}) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/updateStage`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      stageId,
      answers,
      energy,
      time,
      health,
      currentDay,
      powerup,
      resume,
      resetQuestionsMeta,
    }),
  });

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.message || 'Failed to update stage');
  }
  return resp.json();
}
